module.exports = __webpack_public_path__ + "static/4_Defend_2208x1242.56656c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/4_Defend_2208x1242.png
// module id = 1161
// module chunks = 35783957827783